// apps/admin/src/hooks/use-snap-to-grid.ts
//
// P5 UI Polish W2 T2 — pure snap-to-grid helper (spec §3.2).
// Caller passes the step in pixels; step=1 means no snap.

export type SnapStep = 1 | 4 | 8 | 16 | 32;

export function snapToGrid(
  position: { x: number; y: number },
  step: SnapStep,
): { x: number; y: number } {
  if (step <= 1) return position;
  return {
    x: Math.round(position.x / step) * step,
    y: Math.round(position.y / step) * step,
  };
}
